import React, { useEffect } from 'react';
import { Gauge, Rose } from '@ant-design/charts';
import './index.less';

const PageModel = props => {
	const data = [
		{
			type: '已保养设备',
			value: 27,
		},
		{
			type: '临期保养设备',
			value: 25,
		},
		{
			type: '过期未保养设备',
			value: 18,
		},
		
	];
	const config = {
		data,
		xField: 'type',
		yField: 'value',
		seriesField: 'type',
		radius: 0.9,
		legend: {
			position: 'bottom',
		},
	};
	useEffect(() => {

	}, [123]);

	return (
		<Rose {...config} />
	);
};

export default PageModel;
